<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
             <span class="headline font-weight-bold">Metrics - Provide one metric for each of the following:</span> 
             
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                

                 <!-- <v-textarea
                  outline   
                  :rules="textInputRules"
                  :label="metriccustomertitleLabelText"
                  :hint="metriccustomerHintText" 
                  v-model="metriccustomertitle"
                  
                >
                 </v-textarea> 

                <v-textarea outline
                :label="metricsolutionLabelText" 
                v-model="metrictitle" :hint="metricsolutionHintText" 
                :rules="textInputRules"></v-textarea>

                <v-textarea outline
                :label="metricscaleLabelText" 
                v-model="metrictitle2" :hint="metricscaleHintText" 
                ></v-textarea>


                <v-textarea outline
                :label="metricevangelismLabelText" 
                v-model="metricevangelismtitle" :hint="metricevangelismHintText" 
                ></v-textarea>

                <v-textarea outline
                :label="metricevolutionLabelText" 
                v-model="metricevolutiontitle" :hint="metricevolutionHintText" 
                ></v-textarea>

                  <v-textarea outline
                :label="metricecosystemLabelText" 
                v-model="metricecosystemtitle" :hint="metricecosystemHintText" 
                ></v-textarea> -->

                  
                <v-textarea
                  outline  
                  :rules="textInputRules"
                  :label="metricproblemspaceLabelText"
                  v-model="metrictitle"
                > </v-textarea>
      
                <v-textarea 
                outline :label="metricsolutionspaceLabelText" 
                v-model="metrictitle2" 
                :hint="metricsolutionspaceHintText" 
                :rules="textInputRules"
                ></v-textarea>

                <v-textarea outline 
                :label="metricevangelismLabelText" 
                v-model="metrictitle3" :hint="metricevangelismHintText" 
                :rules="textInputRules"></v-textarea>

  
                <v-textarea outline 
                :label="metricscaleLabelText" 
                v-model="metrictitle4" :hint="metricscaleHintText" 
                :rules="textInputRules"></v-textarea>


                <v-textarea outline class="mt-3"
                :label="metricevolutionLabelText" 
                v-model="metrictitle5" :hint="metricevolutionHintText" 
                :rules="textInputRules"></v-textarea>

                <v-textarea outline
                :label="metricecosystemLabelText" 
                v-model="metrictitle6" :hint="metricecosystemHintText" 
                ></v-textarea>
  
<!-- <v-layout
      row
      wrap
      style="width: 40px"
      
    > -->

 

<!-- </v-layout> -->
 

            
                
                <!-- <v-tooltip bottom v-if="customerproblemdetail.componentid && customerproblemdetail.tooltip">
      <template v-slot:activator="{ on }">
                            <v-btn flat icon color="grey" v-on="on">
              <v-icon>help</v-icon>
            </v-btn>
             </template>
      <span>Tooltip</span>
    </v-tooltip> --> 
                  <!-- </v-layout> -->
                <!-- :prepend-icon="customerproblemdetail.prependicon" -->
                <!-- </span> -->
                <!-- <v-text-field
                  outline
                  v-model="title"
                  v-if="includeWhyTheProblemIsImportantToTheCustomer"
                  label="Why is the problem important to the customer?"
                  prepend-icon="folder"
                ></v-text-field> -->

                

                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn @click="submit" flat color="primary" class="mx-2 mt-3" :loading="loading">Head to Growth Marketing</v-btn> -->
                <!-- <v-btn flat to="/addmetricsbif" color="primary" class="mx-2 mt-3" :loading="loading">Add additional metrics</v-btn>  -->
                <v-btn flat to="/addmetricsbif" color="primary" class="mx-2 mt-3" :loading="loading">Add additional metrics</v-btn> 
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "BC foundation elements - Section 01",
  components: {},
  data() {
    return { 
      doWe: false,
      uniquesellingpropositionprimary: 'Employment of the Eisenhower method to task management with an emphasis on the user experience',
      uniquesellingpropositionprimaryLabelText: 'What is the unique selling proposition of this solution.',
 
 
      metrictitle: 'Daily task completion target',
      metricproblemspaceEnabled: true,
      metricproblemspaceLabelText: 'Provide one metric which will help track the customer problem:',

      metrictitle2: 'Task completions per day',
      metricsolutionspaceLabelText: 'Provide one metric for the solution.',
      metricsolutionspaceHintText: 'Provide one metric which will help track the impact of the solution on the customer problem.',
 
      metrictitle3: 'Early adopters acquired per evangelist',
      metricevangelismLabelText: 'Provide one metric to measure evangelism.',
      metricevangelismHintText: 'Provide one metric which will help measure the impact of evangelists sharing this wireframe, when they work to spread the word about the solution and atttract more users to try the solution concept. This can be beneficial to the solution concept since more users will know about it and if they try it out, will be able to provide feedback to improve the product.',

      metrictitle4: 'Monthly active users',
      metricscaleLabelText: 'Provide one metric to handle scale.',
      metricscaleHintText: 'Provide one metric which will help measure the growth of the product, in terms of scale.',
 
      metrictitle5: 'User story relevance count',
      metricevolutionLabelText: 'Provide one metric to measure the evolution of the customer problem.',
      metricevolutionHintText: 'Provide one metric which will help measure the change in the original customer problem. This can help the solution team decide on if the solution is still relevant to solving the problem of the customer or a new solution paradigm needs to be introduced.',
      
      metrictitle6: 'Match count for new concept user stories to pending user stories',
      metricecosystemLabelText: '(Optional) Provide one metric for new parallel solutions.',
      metricecosystemHintText: 'If the problem has evolved significantly and one or more new solutions can be suggested, Please provide one metric which will help measure the usefulness of parallel product concepts built around the original solution idea.',

      // metrictitle: 'Cost to time saved ratio',
      // metricsolutionLabelText: 'A metric to help validate the solution in relation to the customer\'s problem.',
      // metricsolutionHintText: 'Provide one metric which will help track the impact of the solution on the customer problem.',
      // metrictitle2: 'Server cost per user per month',
      // metricscaleLabelText: 'A metric to handle scale',
      // metricscaleHintText: 'Provide one metric which will help measure the aspects of growth of the product, in terms of scale.',
 
      // metriccustomertitle:'Target audience size per demographic',  
      // metriccustomertitleLabelText: 'A metric for the customer\'s problem domain',
      // metriccustomerHintText: 'Provide one metric which will help undestand the customer requirement.',  

      // metricevangelismtitle: '(Potential) Customer conversions per month',
      // metricevangelismLabelText: 'A metric to track the impact of evangelism (based on the product concept).',
      // metricevangelismHintText: 'Provide one metric which will help measure the impact of evangelists sharing this wireframe, when they work to spread the word about the solution and atttract more users to try the solution concept. This can be beneficial to the solution concept since more users will know about it and if they try it out, will be able to provide feedback to improve the product.',

      // metricevolutiontitle: 'Ratio of relevance of disruptive competing offering to current proposed solution',
      // metricevolutionLabelText: 'A metric to measure the evolution of the customer problem.',
      // metricevolutionHintText: 'Provide one metric which will help measure the change in the original customer problem. This can help the solution team decide on if the solution is still relevant to solving the problem of the customer or a new solution paradigm needs to be introduced.',
      // metricecosystemtitle: 'Number of active API adopters per month',
      // metricecosystemLabelText: '(Optional) A metric for potential new parallel solutions (based on current concept).',
      // metricecosystemHintText: 'If the problem has evolved significantly and one or more new solutions can be suggested, Please provide one metric which will help measure the usefulness of parallel product concepts built around the original solution idea.',

      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
 if(this.$refs.form.validate()) {
        //console.log("Attempt to submit")
        this.loading = true;
        //  const project = {

        //   projecttitle: this.projecttitle,
        //   customerproblemdescription: this.customerproblemdescription,
        //   whythisproblem: this.whythisproblem,
        //   targetagerange: this.targetagerange,
        //   problemdomain: this.problemdomain,
        //   additionaldetailforproblem: this.additionaldetailforproblem,
        //   locationofuser: this.locationofuser,
        //   locationofsolutionusage: this.locationofsolutionusage
        // }

        // // db.collection('projects').add(project).then(function(docRef) {
        // //         console.log("Document written with ID: ", docRef.id);
        // //         this.loading = false;


        // //     })
        // //     .catch(function(error) {
        // //         console.error("Error adding document: ", error);
        // //     });

        //    db.collection('projects').add(project).then(() => {
        //   //console.log("added to db!", docRef.id)
        //   this.loading = false;
        //   this.$router.push('addstoriespainpoints')
        // })
      




            const businessdetail = {
          uniquesellingpropositionprimary: this.uniquesellingpropositionprimary 

            }
 

            db.collection('projects').doc(this.getProjectID()).update(businessdetail).then(() => {
                    //console.log("added to db!", this.getProjectID())
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('bcgrowthmarkingdetails')
                    ///this.$emit('firstprefdetailsconfirmed')
                });



      const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Solution'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });

       const metric2 = {
                metrictitle: this.metrictitle2,
                metriccategory: 'Scale'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric2).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projec

    });


        }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    },
    doWeHaveAdditionalDetailsToAdd(){
      this.doWe = this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
  
      //console.log(this.doWe) 
      if (this.doWe.length == 0)
      {
        return false
      }else{
        return true
      }

      //this.doWe = doWe

      //return this.doWe
    }
  }
};
</script>

<style>
</style>
